export default __webpack_public_path__ + "static/hedgies-9f0e31eacc1a06dbdb73dbac5c60efb9.jpg";